import React from "react";
import {
  CustomCalander,
  CustomDropDown,
  CustomForm,
  CustomInputMask,
} from "../AllInputs";
import { MaturityType } from "../AllDropDownOptions";
import MonthsIcon from "assets/images/svg/MonthsIcon.svg"
const Maturity = ({ title, data, handleChange }) => {
  return (
    <>
      <CustomForm title={title ? title : "Maturity"}>
        <CustomDropDown
          data={data}
          onChange={handleChange}
          name="maturityType"
          label={"Type of Maturity"}
          options={MaturityType}
          required
        />
      </CustomForm>
      {data?.maturityType === "None" || data?.maturityType === "" ? null : (
        <CustomForm>
          <CustomCalander
            minDate={new Date()}
            data={data}
            onChange={handleChange}
            name="maturityDate"
            required
          />

          {data?.maturityType === "Automatic Renewal" && (
            <>
              {" "}
              <CustomInputMask
                data={data}
                onChange={handleChange}
                name="maturityExtension"
                spanIcon={MonthsIcon}
                max={9}
                required
              />
              <CustomInputMask
                data={data}
                onChange={handleChange}
                name="noticePeriod"
                spanIcon={MonthsIcon}
                label={"Notice Period"}
                max={9}
                required
              />
            </>
          )}
        </CustomForm>
      )}
    </>
  );
};

export default Maturity;
